import {DataPacket} from '@/base/DataPacket';
//============ wy.core.services.creditEvaluation.creditEvaApplyRecord.vo.QueryVo =============

export class QueryVo extends DataPacket {
    constructor(opts= {}){
        super();
        this.OrgName = opts.OrgName || '';
        this.CreditNumber = opts.CreditNumber || '';
        this.PublicStatus = opts.PublicStatus || null;
        this.MangerTel = opts.MangerTel || '';
        this.MangerNameOrEaAreaName = opts.MangerNameOrEaAreaName || '';
        this.Content = opts.Content || '';
        this.HighScore = opts.HighScore || null;
        this.ItemName = opts.ItemName || '';
        this.ValueMethod = opts.ValueMethod || null;
        this.CreateDateStart = opts.CreateDateStart || null;
        this.OrgCode = opts.OrgCode || '';
        this.EaAreaName = opts.EaAreaName || '';
        this.SuitObj = opts.SuitObj || null;
        this.CreateDateEnd = opts.CreateDateEnd || null;
        this.LowScore = opts.LowScore || null;
        this.MangerName = opts.MangerName || '';
        this.Status = opts.Status || '';
        this.Sfcyjf = opts.Sfcyjf || '';
        this.PjDate = opts.PjDate || '';
    }
}

